import { render, staticRenderFns } from "./assessment-auth.vue?vue&type=template&id=8c9aeda2&scoped=true"
import script from "./assessment-auth.vue?vue&type=script&lang=js"
export * from "./assessment-auth.vue?vue&type=script&lang=js"
import style0 from "./assessment-auth.vue?vue&type=style&index=0&id=8c9aeda2&prod&lang=css"
import style1 from "./assessment-auth.vue?vue&type=style&index=1&id=8c9aeda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9aeda2",
  null
  
)

export default component.exports